import getByIdRequest from "./requests/get-by-id-request";
import deleteByIdRequest from "./requests/delete-by-id-request";
import autoDoneRequest from "./requests/auto-done-request";
import searchEnrollRequest from "./requests/search-enroll-request";
import setEnrollRequest from "./requests/set-enroll-request";
import updateEnrollRequest from "./requests/update-enroll-request";
import searchGroupByParamsRequest from "./requests/search-group-by-params-request";

const enrollRepository = {
    getById: getByIdRequest,
    deleteById: deleteByIdRequest,
    autoDone: autoDoneRequest,
    searchEnroll: searchEnrollRequest,
    setEnroll: setEnrollRequest,
    updateEnroll: updateEnrollRequest,
    searchGroupByParams: searchGroupByParamsRequest,
};

export default enrollRepository;
